import DgDatabasket from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgDatabasket.install = function (Vue) {
  Vue.component(DgDatabasket.name, DgDatabasket)
}
export default DgDatabasket

export { DgDatabasket }